import React, { Fragment, Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import 'date-fns';
//import '../../styles.css';
import { EnhancedTableToolbar, EnhancedTableHead } from '../../utils/common_page_with_table';
import { Global, inlineStyles } from '../../utils/global';
import SnackerBar from '../../utils/SnackerBar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Link, Grid, Checkbox } from '@material-ui/core';

const reportTitle = "Select Role Permissions:";
const EntityName = 'Feature';
const url = 'settings/features.php';

export default class Features extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 1,
            branchId: 0,
            deleteDialogOpen: false,
            dialogAddEditOpen: false,
            dialogMode: '',
            dense: false,
            id: 0,
            isLoading: true,
            isDataLoading: false,
            isDialogDataLoading: false,
            notification: '',
            objName: '',
            order: 'asc',
            orderBy: 'feature',            
            page: 0,
            pageTotal: 0,
            permissions: [],
            rows: [],
            rowsPerPage: 100,
            searchFor: '',
            selected: [],
            initSelected: false,
            snackBarMsg: '',
            snackBarMsgType: '',
            snackBarOpen: false,
            showClearSearchBtn: false,
            url: props.App.state.API_HOST + url,
            parent_id: props.hasOwnProperty('parentComponent') ? props.parentComponent.state.id : 0,
            schema: [],
        };
    }
    openSnackBar = (snackBarMsg, snackBarMsgType, snackBarOpen) => {
        this.setState({ snackBarMsg: snackBarMsg, snackBarMsgType: snackBarMsgType, snackBarOpen: snackBarOpen });
    }
    setComponentState = (sState, vState) => {
        this.setState({ [sState]: vState });
    }
    handleTextfieldChange = (name, key) => e => {
        var values = { ...this.state.schema };
        values[key].value = e.target.value;
        this.setState({ values });
    }
    handleRequestSort = (event, property) => {
        var isDesc = this.state.order === 'desc';
        var order = isDesc || this.state.orderBy !== property ? 'asc' : 'desc';
        var values = {
            order: order,
            orderBy: property,
        };
        this.setComponentState('order', order);
        this.setComponentState('orderBy', property);
        Global.loadList(this, values);
    }
    setSearch = (e) => {
        var v = e.target.value;
        this.setState({ searchFor: v });
        if (v) {
            this.setComponentState('showClearSearchBtn', true);
        } else {
            this.setComponentState('showClearSearchBtn', false);
        }
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            var newSelecteds = this.state.rows.map(n => n.name);
            this.setComponentState('selected', newSelecteds);
            return;
        }
        this.setComponentState('selected', []);
    }

    handleChangePage = (event, newPage) => {
        this.setComponentState('page', newPage);
        Global.loadList(this, { page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setComponentState('rowsPerPage', event.target.value);
        Global.loadList(this, { rowsPerPage: event.target.value });
    }

    handleChangeDense = (event) => {
        this.setComponentState('dense', event.target.checked);
    }

    handleDialogClose = () => {
        this.setDeleteDialogOpen(false);
    }
    confirmDeleteRow(id, name) {
        this.setState({ id: id });
        this.setState({ objName: name });
        this.setDeleteDialogOpen(true);
    }
    confirmDeletion = (id) => {
        Global.deleteRow(this, id);
    }
    setDeleteDialogOpen = (v) => {
        this.setState({ deleteDialogOpen: v });
        if (!v) {
            Global.loadList(this, {});
        }
    }
    setEditDialogOpen = (v) => {
        this.setState({ dialogAddEditOpen: v });
        if (!v) {
            var formValues = this.state.schema;
            var values = { ...this.state.schema };
            formValues.forEach((row, key) => {
                values[key].error = '';
                values[key].value = '';
                this.setState({ values });
            })
            Global.loadList(this, {});
        }
    }

    editRow = (id) => {
        //this.props.parentComponent.selectMenu(editPage,id,{});
        /* Use this 2 lines below instead of you want to edit in a dialog box */
        Global.getOneRow(this, id);
        this.setEditDialogOpen(true);
    }

    addNew = () => {
        //this.editRow(0);        
        /* Use the codes below if you want popup for editing */
        var values = this.state.schema;        
        values.forEach((row,index)=>{
            values[index].value='';            
        })
        this.setState({...this.state, values, id:0 });
        this.setEditDialogOpen(true);
    }

    actionButtons = () => {
        return (
            <Button onClick={this.addNew} style={inlineStyles.buttonBlue} variant='contained' size="small">
                <Icon style={inlineStyles.smallIcon} className="fas fa-plus-circle"></Icon> New {EntityName}
            </Button>
        )
    }
    handleClick = (event, value) => {
        var selected = this.state.selected;
        const selectedIndex = selected.indexOf(value);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, value);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    }

    processSelectedRows = () => {
        /* save selected permissions */
        var values = [];
        values.push({ name: 'selectedId', value: this.state.selected, required: false });
        values.push({ name: 'roleId', value: this.props.parentComponent.state.id, required: false });
        let url = this.props.App.state.API_HOST + 'common/save.php';
        Global.SaveDialogFormData(this, url, values, 'permissions');
    }

    isSelected = (name) => this.state.selected.indexOf(name) !== -1;

    componentDidUpdate() {
        if (!this.state.initSelected && this.state.rows && this.state.rows.length>0) {
            var states = this.state;
            states.initSelected = true;
            var selected = this.state.selected;
            var newSelected = [];
            var value = '';
            this.state.rows.forEach((row) => {
                if (row.module_right) {
                    if (row.module_right.indexOf('f') !== -1) {              
                        value = 'f'+row.id;
                        newSelected = newSelected.concat(selected, value);
                    }
                    if (row.module_right.indexOf('c') !== -1) {              
                        value = 'c'+row.id;
                        newSelected = newSelected.concat(selected, value);
                    }
                    if (row.module_right.indexOf('v') !== -1) {    
                        value = 'v'+row.id;
                        newSelected = newSelected.concat(selected, value);
                    }
                    if (row.module_right.indexOf('u') !== -1) {                   
                        value = 'u'+row.id;
                        newSelected = newSelected.concat(selected, value);
                    }
                    if (row.module_right.indexOf('d') !== -1) {                   
                        value = 'd'+row.id;
                        newSelected = newSelected.concat(selected, value);
                    }
                    
                }                
            })
            states.selected = newSelected;
            this.setState({ states });        
        }
    }
    componentDidMount() {
        if (this.state.isLoading && !this.state.isDataLoading) {
            Global.getSchema(this, false);
        }
    }
    render() {
        var headRows = [];

        var formValues = this.state.schema;
        formValues.forEach((row) => {
            headRows.push({ id: row.name, label: row.label, numeric: row.numeric, showInList: row.showInList });
        });
        headRows.push({ id: '#', label: 'Full', numeric: false, showInList: true });
        headRows.push({ id: '#', label: 'Create', numeric: false, showInList: true });
        headRows.push({ id: '#', label: 'View', numeric: false, showInList: true });
        headRows.push({ id: '#', label: 'Update', numeric: false, showInList: true });
        headRows.push({ id: '#', label: 'Delete', numeric: false, showInList: true });
        return (
            <Fragment>
                <Paper style={inlineStyles.paper}>
                    {
                        this.state.notification &&
                        <Typography paragraph color="error" align="center" style={{ 'padding': 20 }}>
                            {this.state.notification}
                        </Typography>
                    }
                    {
                        this.state.isDataLoading &&
                        <Fragment>
                            <div style={{ 'padding': 50, 'textAlign': 'center' }}>
                                <CircularProgress />
                            </div>
                        </Fragment>
                    }
                    {!this.state.isDataLoading &&
                        <Fragment>
                            <EnhancedTableToolbar
                                numSelected={this.state.selected ? this.state.selected.length : 0}
                                toolbarTitle={reportTitle}
                                showSearchBox={true}
                                actionButtons={this.actionButtons}
                                selectedLabel='Save Permissions'
                                t={this}
                                Global={Global}
                            />
                            <div style={inlineStyles.tableWrapper}>
                                <Table
                                    style={inlineStyles.table}
                                    aria-labelledby="tableTitle"
                                    size={this.state.dense ? 'medium' : 'small'}
                                >
                                    <EnhancedTableHead
                                        numSelected={this.state.selected ? this.state.selected.length : 0}
                                        order={this.state.order}
                                        orderBy={this.state.orderBy}
                                        onSelectAllClick={this.handleSelectAllClick}
                                        onRequestSort={this.handleRequestSort}
                                        headRows={headRows}
                                    />
                                    <TableBody>
                                        {this.state.rows && this.state.rows.length > 0 && this.state.rows.map((row, index) => {
                                            const labelId = `table-row-${row.id}`;
                                            return (
                                                <TableRow
                                                    hover
                                                    tabIndex={-1}
                                                    key={row.id}
                                                >
                                                    <TableCell className="listRowNum" id={labelId} scope="row" padding="none" align="center">
                                                        {index + 1 + (this.state.page * this.state.rowsPerPage)}
                                                    </TableCell>
                                                    {formValues.filter(col => col.showInList).map((col, colindex) => {
                                                        const colval = colindex
                                                            ? row[col.name]
                                                            : (<Link to="#" onClick={() => this.editRow(row.id)} aria-label="Edit row">{row[col.name]}</Link>);
                                                        return (
                                                            <TableCell key={colindex} align={col.numeric ? 'right' : (col.align ? col.align : 'left')}>
                                                                {colval}
                                                            </TableCell>
                                                        );
                                                    })
                                                    }
                                                    <TableCell padding="checkbox" align="center">
                                                        <Checkbox color="primary"
                                                            onClick={event => this.handleClick(event, 'f' + row.id)}
                                                            checked={this.isSelected('f' + row.id)}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding="checkbox" align="center">
                                                        <Checkbox color="primary"
                                                            onClick={event => this.handleClick(event, 'c' + row.id)}
                                                            checked={this.isSelected('c' + row.id) && !this.isSelected('f' + row.id)}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                            disabled={this.isSelected('f' + row.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding="checkbox" align="center">
                                                        <Checkbox color="primary"
                                                            onClick={event => this.handleClick(event, 'v' + row.id)}
                                                            checked={this.isSelected('v' + row.id) && !this.isSelected('f' + row.id)}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                            disabled={this.isSelected('f' + row.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding="checkbox" align="center">
                                                        <Checkbox color="primary"
                                                            onClick={event => this.handleClick(event, 'u' + row.id)}
                                                            checked={this.isSelected('u' + row.id) && !this.isSelected('f' + row.id)}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                            disabled={this.isSelected('f' + row.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding="checkbox" align="center">
                                                        <Checkbox color="primary"
                                                            onClick={event => this.handleClick(event, 'd' + row.id)}
                                                            checked={this.isSelected('d' + row.id) && !this.isSelected('f' + row.id)}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                            disabled={this.isSelected('f' + row.id)}
                                                        />
                                                    </TableCell>

                                                </TableRow>
                                            );
                                        })
                                        }
                                        {this.state.rows && !this.state.rows.length &&
                                            <TableRow><TableCell align="center" colSpan={3}>{"No result"}</TableCell></TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </div>
                            {!this.state.isDataLoading && this.state.pageTotal > 1 &&
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    component="div"
                                    count={this.state.count}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            }
                        </Fragment>
                    }
                </Paper>
                <FormControlLabel
                    control={<Switch checked={this.state.dense} onChange={this.handleChangeDense} />}
                    label="Show bigger cells"
                />
                <Dialog
                    open={this.state.deleteDialogOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText id="alert-dialog-description"></DialogContentText>
                        <div style={{ padding: 15 }}>
                            Do you want to continue deleting "{this.state.objName}"?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDeleteDialogOpen(false)} variant='contained' color="secondary" size="small" style={inlineStyles.button}>
                            No
                    </Button>
                        <Button onClick={() => this.confirmDeletion(this.state.id)} variant='contained' color="primary" size="small" style={inlineStyles.button} autoFocus>
                            Yes
                    </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.dialogAddEditOpen}
                    aria-labelledby="alert-dialog2-title"
                    aria-describedby="alert-dialog2-description"
                >
                    <DialogTitle id="alert-dialog2-title">{this.state.id ? "Edit " + EntityName : "Add a " + EntityName}</DialogTitle>
                    <DialogContent dividers style={{ width: 600 }}>
                        <DialogContentText id="alert-dialog2-description">* Required</DialogContentText>
                        <Fragment>

                            {
                                this.state.notification &&
                                <Typography paragraph color="error" align="center" style={{ 'padding': 5 }}>
                                    {this.state.notification}
                                </Typography>
                            }
                            {
                                this.state.isDialogDataLoading &&
                                <div style={{ padding: 20, minWidth: 350, textAlign: 'center' }}>
                                    <CircularProgress />
                                </div>
                            }
                            {!this.state.isDialogDataLoading &&
                                <Fragment>
                                    <Grid container spacing={2}>
                                        {formValues.map((row, index) => {
                                            return (
                                                <Grid item xs={12} md={row.gridsize ? row.gridsize : 6} key={index}>
                                                    <TextField
                                                        error={row.error ? true : false}
                                                        variant="outlined"
                                                        margin="dense"
                                                        autoFocus={row.autoFocus}
                                                        name={row.name}
                                                        required={row.required}
                                                        label={row.error ? row.error : row.label}
                                                        value={row.value}
                                                        InputLabelProps={{
                                                            shrink: true
                                                        }}
                                                        onChange={this.handleTextfieldChange(row.name, index)}
                                                        disabled={this.state.isDialogDataLoading}
                                                    />
                                                </Grid>
                                            )
                                        })
                                        }
                                    </Grid>
                                </Fragment>
                            }

                        </Fragment>


                    </DialogContent>
                    <DialogActions>
                        <Button onClick={Global.handleSaveForm(this)} variant='contained' color="primary" size="small" style={inlineStyles.button} autoFocus>
                            Save
                    </Button>
                        <Button onClick={() => this.setEditDialogOpen(false)} variant='contained' color="secondary" size="small" style={inlineStyles.button}>
                            Close
                    </Button>
                    </DialogActions>
                </Dialog>
                <SnackerBar msg={this.state.snackBarMsg} msgType={this.state.snackBarMsgType} opened={this.state.snackBarOpen} t={this} />
            </Fragment>
        );
    }
}
